import axiosInstance from "../axiosInstance";

// Get paginated categories with optional filters
export const getPaginatedCategories = async ({ page = 1, limit = 10, filters = {} } = {}) => {
    const params = new URLSearchParams();

    params.append("page", page);
    params.append("limit", limit);

    for (const key in filters) {
        if (filters[key] !== undefined && filters[key] !== "") {
            params.append(key, filters[key]);
        }
    }

    const response = await axiosInstance.get(`categories/all-category?${params.toString()}`);
    return response.data;
};

// Get total count of categories with optional filters
export const getCategoryCount = async (filters = {}) => {
    const params = new URLSearchParams();

    for (const key in filters) {
        if (filters[key] !== undefined && filters[key] !== "") {
            params.append(key, filters[key]);
        }
    }

    const response = await axiosInstance.get(`count?dataType=categories&${params.toString()}`);
    return response.data.total || 0;
};

export const uploadCategory = async (categoryData) => {
    try {
        const response = await axiosInstance.post("/categories/upload-category", categoryData);
        return response.data;
    } catch (error) {
        console.error("Error uploading category:", error);
        return {
            success: false,
            error: error.response?.data?.message || error.message
        };
    }
};

export const getCategoryByID = async (categoryID) => {
    try {
        const response = await axiosInstance.get(`/categories/detail/${categoryID}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching category:", error);
        return {
            success: false,
            error: error.response?.data?.message || error.message
        };
    }
};


export const updateCategory = async (payload) => {
    try {
        const response = await axiosInstance.put("/categories/edit", payload);
        return response.data;
    } catch (error) {
        console.error("Error updating category:", error);
        return {
            success: false,
            error: error.response?.data?.message || error.message
        };
    }
};

export const deleteCategory = async (categoryID) => {
    try {
        const response = await axiosInstance.delete(`/categories/delete/${categoryID}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting category:", error);
        return {
            success: false,
            error: error.response?.data?.message || error.message
        };
    }
};

// Featured Category APIs
export const getFeaturedCategories = async () => {
    try {
        const response = await axiosInstance.get("/categories/featured");
        return response.data;
    } catch (error) {
        console.error("Error fetching featured categories:", error);
        return { success: false, error: error.message };
    }
};

export const bulkSetFeatured = async (categoryIDs, isFeatured) => {
    try {
        const response = await axiosInstance.put("/categories/bulk-featured", { categoryIDs, isFeatured });
        return response.data;
    } catch (error) {
        console.error("Error bulk updating featured status:", error);
        return { success: false, error: error.message };
    }
};

export const reorderCategories = async (reorderedItems) => {
    try {
        const response = await axiosInstance.put("/categories/reorder", { reorderedItems });
        return response.data;
    } catch (error) {
        console.error("Error reordering categories:", error);
        return { success: false, error: error.message };
    }
};

export const reorderAllCategories = async (reorderedItems) => {
    try {
        const response = await axiosInstance.put("/categories/reorder-all", { reorderedItems });
        return response.data;
    } catch (error) {
        console.error("Error reordering categories:", error);
        return { success: false, error: error.message };
    }
};

// Mega Menu Products & Redis Cache Revalidation APIs
export const getCategoryMegamenuProducts = async (categoryID) => {
    try {
        const response = await axiosInstance.get(`/categories/megamenu-products/${categoryID}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching category megamenu products:", error);
        return { success: false, error: error.response?.data?.message || error.message };
    }
};

export const saveCategoryMegamenuProducts = async (categoryID, productIDs) => {
    try {
        const response = await axiosInstance.post("/categories/megamenu-products", { categoryID, productIDs });
        return response.data;
    } catch (error) {
        console.error("Error saving category megamenu products:", error);
        return { success: false, error: error.response?.data?.message || error.message };
    }
};

export const revalidateMegamenuCache = async () => {
    try {
        const response = await axiosInstance.post("/categories/megamenu-revalidate");
        return response.data;
    } catch (error) {
        console.error("Error revalidating megamenu cache:", error);
        return { success: false, error: error.response?.data?.message || error.message };
    }
};
